export enum COUPON_TYPE_GROUP {
  UNKNOWN = 0,
  DAILY_RANGE = 1000,
  DAILY_HOUR = 2000,
  DAILY_CONSECUTIVE = 3000,
  MONTHLY = 10000
}

export enum COUPON_TYPE_SEQ {
  DAILY = 0,
  MONTHLY_PERIOD = 10100, // 기간권
  MONTHLY_UNIT = 10200, // 월단위권
  MONTHLY_PARTIAL = 10300 // 일할권
}

export enum PARKINGLOT_TYPE {
  PARKINGLOT = 'P',
  SHARE = 'S'
}

export enum SHEET_STATE_TYPE {
  CLOSE = '0',
  HIDDEN = '1',
  VISIBLE = '2'
}

export enum SALE_TYPE {
  OFF = '0',
  ON = '1'
}

export enum CATEGORY_SEQ {
  PUBLIC = 1,
  PRIVATE = 2
}

export enum CATEGORY_LABEL {
  PUBLIC = '공영',
  PRIVATE = '민영'
}
